<template>
    <div class="loader-main-div text-center mt-4 mb-4" role="status">
        <div class="loader-mark position-relative mx-auto" :class="{ 'loader-mark--yservices': isYservices }" aria-hidden="true">
            <span class="loader-bar"></span>
            <span class="loader-bar loader-bar--bottom"></span>
        </div>
        <div :class="{ 'visually-hidden': !loadingMessage }">{{ loadingMessage || defaultMessage }}</div>
    </div>
</template>

<script>
export default {
    name: "LoaderComponent",
    props: {
        message: {
            default: null,
        },
        i18nAvailable: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        isYservices() {
            return THEME === "yservices";
        },
        defaultMessage() {
            return this.i18nAvailable ? this.$tl("labels.loading") : "Veuillez patienter...";
        },
        loadingMessage() {
            return this.message !== null ? this.message : this.defaultMessage;
        },
    },
};
</script>

<style scoped type="text/css">
.loader-mark {
    --loader-color-start: #289bad;
    --loader-color-end: #0d4163;
    --loader-bar-width: 70px;
    --loader-bar-height: 18px;
    --loader-bar-radius: 9px;
    --loader-bar-angle: -35deg;
    width: 96px;
    height: 80px;
}

.loader-mark--yservices {
    --loader-color-start: #1ca8df;
    --loader-color-end: #2e84d7;
}

.loader-bar {
    --loader-shift-x: -18px;
    --loader-shift-y: 12px;
    position: absolute;
    left: calc(50% + 0.5px - var(--loader-bar-width) / 2);
    top: calc(22.8px - var(--loader-bar-height) / 2);
    width: var(--loader-bar-width);
    height: var(--loader-bar-height);
    border-radius: var(--loader-bar-radius);
    background: linear-gradient(to right, var(--loader-color-start), var(--loader-color-end));
    transform: rotate(var(--loader-bar-angle));
    animation: loader-slide 2s linear infinite;
}

.loader-bar--bottom {
    --loader-shift-x: 18px;
    --loader-shift-y: -12px;
    left: calc(50% - 0.5px - var(--loader-bar-width) / 2);
    top: calc(49.7px - var(--loader-bar-height) / 2);
    background: linear-gradient(to left, var(--loader-color-start), var(--loader-color-end));
}

@keyframes loader-slide {
    50% {
        transform: translate(var(--loader-shift-x), var(--loader-shift-y)) rotate(var(--loader-bar-angle));
    }
}

@media (prefers-reduced-motion: reduce) {
    .loader-bar {
        animation: none;
    }
}
</style>
